import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseComponent, DamItemVersion, DocumentExif, FileService} from 'compob2b-libs';
import {FileUploader} from 'ng2-file-upload';
import {from, Subscription} from 'rxjs';
import {catchError, concatMap, finalize, map, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../../../../environments/translations.ru';
import {DamService} from '../../../../../dam.service';
import {DamItemVersionsRenameComponent} from '../../../../dam-item-versions-rename/dam-item-versions-rename.component';
import {DamItemVersionTypeCountWSelected} from '../../../../dam-table/dam-catalog.component';

@Component({
  selector: 'app-dam-item-versions',
  templateUrl: './dam-item-versions.component.html',
  styleUrls: ['./dam-item-versions.component.scss'],
})
export class DamItemVersionsComponent extends BaseComponent implements OnInit {
  constructor(protected readonly fileService: FileService,
              protected readonly damService: DamService) {
    super();
  }

  uploader: FileUploader;
  private uploadSubscription: Subscription;

  ngOnInit(): void {
    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 4000 * 1024 * 1024,
    });
  }

  public upload(): void {
    if (this.uploader.queue.length) {
      this.uploadSubscription = from(this.uploader.queue)
        .pipe(
          catchError(err => this.handleError(err)),
          map(uploadingFile => uploadingFile._file),
          concatMap(uploadingFile => this.compoApiService.postForm(
            '/dam/upload-version-history/' + this.clickedDamItemVersion.id,
            {enabled: true, header: uploadingFile.name, fileInput: uploadingFile}
          )),
          tap(response => {
            if (!response.success) {
              this.warningToast('Данный файл уже загружен раннее');
            }
          }),
          takeUntil(this.unsubscribe),
          finalize(() => {
            this.uploader.clearQueue();
            this.uploadSubscription.unsubscribe();
            window.location.reload();
          }),
        ).subscribe();
    }
  }

  @Input() modelId: string;
  @Input() write: boolean = false;
  @Input() currentVersion = null;
  @Input() versionsHistory: DamItemVersion[] = [];
  @Input() damItemVersions: DamItemVersion[] = [];
  @Input() fileExtensions: DamItemVersionTypeCountWSelected[] = [];

  @Input() exifIid: number;
  @Output() versionSelectEvent = new EventEmitter<DamItemVersion>();
  documentExifList: DocumentExif[] = [];
  filteredVersions = 0;

  clickedDamItemVersion: DamItemVersion = null;
  version = translations.version;
  versions = translations.versions;

  getExif(damItemVersionId: number, iid: number) {
    if (this.exifIid === iid) {
      return;
    }
    this.exifIid = iid;
    this.compoApiService.get<DocumentExif[]>('/dam/exif-data-of-version/' + damItemVersionId)
      .pipe(take(1))
      .subscribe(response => {
        this.documentExifList = response.data;
        this.cdr.detectChanges();
      });
  }

  getHistory(version: DamItemVersion) {
    this.clickedDamItemVersion = version;
    this.compoApiService.get<DamItemVersion[]>('/dam/' + version.id + '/versions-history').subscribe(response => {
      this.versionsHistory = response.data;
      this.cdr.detectChanges();
    });
  }

  filterSidebarFilter($event) {
    this.damItemVersions.forEach(item => {
      if ($event.srcElement.value != '') {
        item.hideExpression = !item.header.toUpperCase().includes($event.srcElement.value.toUpperCase());
      } else {
        item.hideExpression = false;
      }
    });
    this.cdr.detectChanges();
  }

  formatBytes(a, b = 2) {
    if (!+a) {
      return '0 Bytes';
    }
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'][d]}`;
  }

  selectVersion(damItemVersion: DamItemVersion) {
    this.versionSelectEvent.emit(damItemVersion);
  }

  isAllExtensionsSelected = false;

  onFileExtensionToggle(index: number): void {
    this.fileExtensions[index].selected = !this.fileExtensions[index].selected;
    this.isAllExtensionsSelected = this.allItemsSelected(this.fileExtensions);
    this.filterVersions(this.damItemVersions);
  }

  allItemsSelected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => item?.selected));
  }

  allItemsUnselected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => !item?.selected));
  }

  filterVersions(damItemVersions: DamItemVersion[]) {
    if (this.allItemsUnselected(this.fileExtensions)) {
      return damItemVersions;
    }

    const selectedExtensionsNames: string[] = this.fileExtensions.map(extension => {
      if (extension.selected) {
        return extension.typeOfFile;
      }
    }).filter(Boolean);

    this.filteredVersions = this.damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    }).length;

    return damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    });
  }

  drop(event: CdkDragDrop<DamItemVersion[]>) {
    if (this.write) {
      console.log('event', event);
      console.log('event.previousIndex', event.previousIndex);
      console.log('event.currentIndex', event.currentIndex);
      moveItemInArray(this.damItemVersions, event.previousIndex, event.currentIndex);
      console.log('damItemVersions after sort', this.damItemVersions);
      let sortedDamItemVersionIds = [];
      this.damItemVersions.forEach(item => {
        sortedDamItemVersionIds.push(item.id);
      });
      console.log('damItemVersions IDS after sort', sortedDamItemVersionIds);
      this.compoApiService.post('/dam/item-versions-sort/' + this.modelId, {
        sortedDamItemVersionIds
      }).pipe(takeUntil(this.unsubscribe)).subscribe();
    }
  }

  public download(id: number, header: string): void {
    this.fileService.downloadUrl('/dam/download/' + id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, header);
      });
  }

  makeActual(damItemVersionHistoryId: number) {
    this.compoApiService.get('/dam/change-actual-dam-version/' + this.clickedDamItemVersion.id + '/' + damItemVersionHistoryId)
      .pipe(takeUntil(this.unsubscribe)).subscribe(_ => {
      window.location.reload();
    });
  }

  modalRename(version: DamItemVersion) {
    this.windowService.open(DamItemVersionsRenameComponent, {
      context: {version: version},
      title: translations.dam.rename,
    }).onClose.subscribe(version => {
      if (version) {
        this.loading = true;
        this.compoApiService.get<DamItemVersion[]>('/dam/' + this.modelId + '/versions').subscribe(response => {
          this.loading = false;
          this.damItemVersions = response.data;
          this.selectVersion(version);
          this.cdr.detectChanges();
        });
      }
    });
  }

  loadDamItemVersions() {
    this.compoApiService.get<DamItemVersion[]>('/dam/' + this.modelId + '/versions').subscribe(response => {
      this.damItemVersions = response.data;
      this.cdr.detectChanges();
    });
  }
}
